const TELEGRAM_TAG_PATTERN = /^@[A-Za-z0-9_]{5,32}$/;

export const isTelegramTagValid = (value) => {
    if (!value) {
        return true;
    }

    return TELEGRAM_TAG_PATTERN.test(value.trim());
};
